var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEbusinessAuth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-auth_svg__a",
    d: "M7.7 14.9v.6c0 .2-.1.3-.3.3h-4c-.6 0-1.1-.5-1.1-1.1V3.4c0-.6.5-1.1 1.1-1.1h8.2c.6 0 1.1.5 1.1 1.1v.9c0 .2-.1.3-.3.3h-.6c-.2 0-.3-.1-.3-.3v-.9H3.4v11.2h4c.1 0 .3.2.3.3zM4.8 9.3h2c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3h-2c-.2 0-.3-.1-.3-.3v-.6c0-.2.2-.3.3-.3zm0-2.3h3.1c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H4.8c-.1 0-.3-.2-.3-.3v-.6c0-.1.2-.3.3-.3zm0-2.2H9c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H4.8c-.2 0-.3-.1-.3-.3v-.6c0-.2.2-.3.3-.3zm4 9.8h6.8c.2 0 .3.1.3.3v.6c0 .2-.1.3-.3.3H8.8c-.2 0-.3-.1-.3-.3v-.6c0-.1.1-.3.3-.3zm5.6-3.4c.8 0 1.4.6 1.4 1.4v.6c0 .5-.4.8-.8.8H9.3c-.5 0-.8-.4-.8-.8v-.6c0-.8.6-1.4 1.4-1.4h.1l.6-2c-.5-.4-.7-1-.7-1.7 0-1.2 1-2.2 2.2-2.2s2.2 1 2.2 2.2c0 .6-.3 1.2-.7 1.7l.6 2h.2zm.3 1.7v-.3c0-.2-.1-.3-.3-.3h-1l-1.1-3.6.4-.2c.3-.2.5-.6.5-1 0-.6-.5-1.1-1.1-1.1S11 7 11 7.6c0 .4.2.8.5 1l.4.2-1.1 3.6h-1c-.2 0-.3.1-.3.3v.3h5.2z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-auth_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-auth_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ebusiness-auth_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ebusiness-auth_svg__c",
    d: "M-786-1556H638V438H-786z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ebusiness-auth_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ebusiness-auth_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#ebusiness-auth_svg__d)",
    d: "M-2.7-2.8h23.5v23.5H-2.7z"
  }))));
}

export default SvgEbusinessAuth;